module.exports = __webpack_public_path__ + "static/media/022_v1_pricing_plans.7c65da29.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/022_v1_pricing_plans.png
// module id = 401
// module chunks = 0